module.exports = __webpack_public_path__ + "img/Purple_Mixed.51b2c7c1.png";